import * as party from 'party-js';

// Confetti colors extracted from the success screen image
const CONFETTI_COLORS = [
  '#FF6B6B', // Red/Pink
  '#4ECDC4', // Teal
  '#45B7D1', // Light Blue
  '#96CEB4', // Mint Green
  '#FECA57', // Yellow
  '#FF9FF3', // Pink
  '#54A0FF', // Blue
  '#48DBFB', // Sky Blue
  '#A29BFE', // Purple
  '#FD79A8', // Rose
  '#FDCB6E', // Orange
  '#6C5CE7', // Deep Purple
];

// Confetti burst positions
const DEFAULT_POSITIONS = [
  { x: 0.3, y: 0.3 },
  { x: 0.5, y: 0.35 },
  { x: 0.7, y: 0.3 },
];

interface ConfettiOptions {
  delay?: number;
  positions?: Array<{ x: number; y: number }>;
  count?: { min: number; max: number };
  size?: { min: number; max: number };
  speed?: { min: number; max: number };
  spread?: number;
  shapes?: Array<'square' | 'circle'>;
}

/**
 * Triggers a confetti animation with customizable options
 * @param options - Configuration options for the confetti effect
 */
export function triggerConfetti(options: ConfettiOptions = {}) {
  const {
    delay = 0,
    positions = DEFAULT_POSITIONS,
    count = { min: 40, max: 60 },
    size = { min: 0.8, max: 1.4 },
    speed = { min: 300, max: 500 },
    spread = 50,
    shapes = ['square', 'circle'],
  } = options;

  setTimeout(() => {
    positions.forEach((pos, index) => {
      setTimeout(() => {
        const element = document.createElement('div');
        element.style.position = 'fixed';
        element.style.left = `${pos.x * 100}%`;
        element.style.top = `${pos.y * 100}%`;
        element.style.width = '1px';
        element.style.height = '1px';
        element.style.pointerEvents = 'none';
        document.body.appendChild(element);

        party.confetti(element, {
          count: party.variation.range(count.min, count.max),
          size: party.variation.range(size.min, size.max),
          speed: party.variation.range(speed.min, speed.max),
          spread,
          shapes,
          color: () =>
            party.Color.fromHex(
              CONFETTI_COLORS[
                Math.floor(Math.random() * CONFETTI_COLORS.length)
              ]
            ),
        });

        // Clean up the temporary element
        setTimeout(() => {
          document.body.removeChild(element);
        }, 100);
      }, index * 120);
    });
  }, delay);
}
